<template>
  <DotLabel
    class="nixia-connection-status"
    :title="connected ? 'Conectado' : 'Desconectado'"
    :color="connected ? 'success' : 'danger'"
    size="small"
  />
</template>

<script>
import DotLabel from "@/ui/layout/DotLabel";
import { mapState } from "vuex";

export default {
  name: "NixiaConnectionStatus",
  components: { DotLabel },
  computed: {
    ...mapState("nixia", ["connected"]),
  },
};
</script>

<style scoped>
.nixia-connection-status {
  align-self: flex-end;
}
</style>
